module.exports = __webpack_public_path__ + "static/media/honda-logo.327f8837.png";